const Style = {

  onboarding: 'flex items-center justify-center bg-gradient-to-b from-main-300 to-main-500 min-h-full text-left'

}

export default Style;